module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cal",
    class: {
      'cal--is-dayview': _vm.isDayView
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "full-spinner"
  }, [_c('div', {
    staticClass: "icon-docendo animated pulse infinite"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30cf0185!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/FullCal.vue
// module id = 1534
// module chunks = 1